import React, { useState } from "react";
import { useOrderedProductsQuery,useDetaildOrderQuery } from "../../services/orderApi";
import QRCode from "qrcode.react";
import { GoBook } from "react-icons/go";
import { IoWarningOutline } from "react-icons/io5";
import { IoTriangleOutline } from "react-icons/io5";
import { MdDoNotDisturb } from "react-icons/md";
import "./orderedProducts.css";
import { IoBookOutline } from "react-icons/io5";
import { SlCalender } from "react-icons/sl";
import { useCurrency } from '../currency/currencyContext'; // Add currency context

function OrderedProducts(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  let order_Id = props.data;
  const { formatPrice, getCurrencySymbol, convertPrice, getCurrentCurrency } = useCurrency(); // Add currency context

  const {
    data: products,
    isLoading,
    isError,
    error,
  } = useOrderedProductsQuery(order_Id);
const {
  data: orderDetails,
  isLoading: detailsLoading,
  isError: detailsError,
  error: detailsErrorData,
} = useDetaildOrderQuery(order_Id);
  if (isLoading) return <div className="loading-spinner">Loading...</div>;
  if (isError) return <div className="error-message">An error occurred: {error.error}</div>;

if (detailsError) return <div className="error-message">An error occurred: {detailsErrorData.error}</div>;

  // How many labels a product needs = its quantity (at least 1)
  const getQty = (data) => {
    const qty = parseInt(data?.quantity, 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  };

  const printLabel = (country) => {
    const labelElement = document.getElementById("print-label");
    const ukAddress = `House # 13, Street # 14, Sector C1 -<br /> Bahria Enclave, Islamabad`;
    const pkAddress = `House # 13, Street # 14, Sector C1 -<br /> Bahria Enclave, Islamabad`;

    // Clone the element to avoid modifying the original
    const labelClone = labelElement.cloneNode(true);

    // Update the address based on country
    const addressElements = labelClone.getElementsByClassName("label-address");

    for (let el of addressElements) {
      el.innerHTML = country === 'uk' ? ukAddress : pkAddress;
    }

    // The made-in text remains the same for both countries
    // No need to update it as it's static now

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Label</title>
          <style>
            @page { size: 60mm 70mm; margin: 0; }
            body { display: flex; justify-content: center; align-items: center; height: 98vh; margin: 0; background-color: white; }
            #print-label { width: 60mm; height: 70mm; text-align: center; padding: 10px; }
          </style>
        </head>
        <body>
          <div id="print-label">${labelClone.innerHTML}</div>
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() { window.close(); };
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // Print labels of ALL products of this order in one go (one label per page)
  // Each product is repeated as many times as its quantity (see hidden list below)
  const printAllLabels = () => {
    const container = document.getElementById("print-all-labels");
    if (!container || !products || products.length === 0) return;

    const pagesHtml = Array.from(container.getElementsByClassName("bulk-label"))
      .map((el) => `<div class="label-page">${el.innerHTML}</div>`)
      .join("");

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print All Labels</title>
          <style>
            @page { size: 60mm 70mm; margin: 0; }
            body { margin: 0; background-color: white; }
            .label-page {
              width: 60mm;
              height: 70mm;
              box-sizing: border-box;
              overflow: hidden;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              page-break-after: always;
              break-after: page;
            }
            .label-page:last-child { page-break-after: auto; break-after: auto; }
          </style>
        </head>
        <body>
          ${pagesHtml}
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() { window.close(); };
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // Label layout (shared by modal preview and bulk print)
  const renderLabel = (product, withId) => (
    <div
        id={withId ? "print-label" : undefined}
        style={{
          width: "60mm",
          height: "70mm",
          backgroundColor: "white",
        }}
    >
      <div
          style={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: "0.6rem",
            fontFamily: "Arial Black",
          }}
      >
        {product.product_Id.product_Name}
      </div>

      <div style={{textAlign: "right"}}>
        <span
            style={{
              fontWeight: "bold",
              fontSize: "0.5rem",
              fontFamily: "Arial Black",
            }}
        >
          SKU: {product.product_Id.SKU}
        </span>
      </div>
      <div
          style={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: "0.6rem",
            fontFamily: "Arial Black",
          }}
      >
        {orderDetails.customer.first_Name} {orderDetails.customer.last_Name}
      </div>
      <div
          style={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: "0.5rem",
            fontFamily: "Arial Black",
          }}
      >
        Order ID: {orderDetails.order_Tracking_Id}
      </div>
      <div
          style={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: "0.5rem",
            fontFamily: "Arial Black",
          }}
      >
        Customer Ref: {orderDetails.customer_Reference}
      </div>

      <hr style={{border: "1px solid black", marginTop: '5px', marginBottom: '5px'}}/>

      <div
          style={{
            display: "flex",
            alignItems: "center", // vertically center
            fontWeight: "bold",
            fontSize: "0.4rem",
            marginBottom: "10px",
            textAlign: "left",
          }}
      >
        <SlCalender
            style={{width: "13px", height: "13px", marginRight: "3px"}}
        />
        <div
            style={{
              fontSize: "0.5rem",
              fontFamily: "Arial Black",
            }}
        >
          {orderDetails.order_Placment_Date}
        </div>
      </div>
      <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "0.6rem",
            fontWeight: "bold",
            fontFamily: "Arial Black",
            gap: "5px", // Adjust space between box and value
          }}
      >
        <div
            style={{
              border: "1px solid black",
              padding: "1px 4px",
              fontSize: "0.5rem",
              fontWeight: "bold",

              marginBottom: "5px",
            }}
        >
          LOT
        </div>
        <div>{product.product_Id.lot_number || "N/A"}</div>
      </div>
      <div
          style={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
          }}
      >
        <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
          <IoWarningOutline style={{width: "50px", height: "50px", marginLeft: "0"}}/>

          <div style={{position: "relative", display: "flex", alignItems: "center"}}>
            <IoBookOutline size={50}/>
            <span
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "75%",
                  transform: "translate(-40%, -60%)",
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  fontFamily: "Arial Black"
                }}
            >
              i
            </span>
          </div>

          <div style={{position: "relative", display: "flex", alignItems: "center"}}>
            <IoTriangleOutline size={50}/>
            <span
                style={{
                  position: "absolute",
                  top: "60%",
                  left: "45%",
                  transform: "translate(-40%, -60%)",
                  fontSize: "0.4rem",
                  fontWeight: "bold",
                }}
            >
              Non
              <br/>
              Sterile
            </span>
          </div>

          <div style={{position: "relative", display: "flex", alignItems: "center"}}>
            <MdDoNotDisturb size={50}/>
            <span
                style={{
                  position: "absolute",
                  top: "55%",
                  left: "50%",
                  transform: "translate(-40%, -60%)",
                  fontSize: "25px",
                  color: "black",
                  fontFamily: "Arial Black"
                }}
            >
              2
            </span>
          </div>
        </div>
      </div>
      <hr style={{border: "1px solid black", marginTop: '0'}}/>
      <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "0.6rem",
            fontWeight: "bold",
          }}
      >
        <div
            style={{
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
        >
          <img
              src="/label-icon/crowbar.jpg"
              style={{width: "15px", height: "15px", fontFamily: "Arial Black"}}
              alt="icon"
          />
          <span style={{fontFamily: "Arial Black"}}>Hira Tech International Solutions</span>
        </div>
      </div>
      <div
          className="label-address"
          style={{
            textAlign: "left",
            fontSize: "0.5rem",
            fontWeight: "bold",
            fontFamily: "Arial Black",
          }}
      >
        House # 13, Street # 14, Sector C1 -
        <br/> Bahria Enclave, Islamabad
      </div>
    </div>
  );

  return (
    <div className="container">
      {/* Print all labels button (right side, just below the "Ordered Products" heading) */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <button
          onClick={printAllLabels}
          disabled={!products || products.length === 0}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: "bold",
            color: "white",
            backgroundColor: "#004aad",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Print All Labels
        </button>
      </div>

      <div className="table-container">
        <table className="products-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Product No.</th>
              <th>Name</th>
              <th>Price</th>
              <th>Qty</th>
              <th>SKU</th>
              <th>QR Code</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {products.map((data, index) => {
              const qrCodeValue = `https://pk.hira-tech.co.uk/product/${data.product_Id.product_Id}`;
              return (
                <tr key={index}>
                  <td>
                    <img
                      src={`http://backend.hira-tech.co.uk${data.product_Id.imageGallery.image1}`}
                      alt="product"
                      className="product-image"
                    />
                  </td>
                  <td>{data.product_Id.product_Id}</td>
                  <td className="product-name">
                    {data.product_Id.product_Name}
                  </td>
                  <td>{formatPrice(data.price_per_unit)}</td> {/* Updated this line */}
                  <td>{data.quantity}</td>
                  <td>{data.product_Id.SKU}</td>
                  <td>
                    <QRCode
                      value={qrCodeValue}
                      size={60}
                      className="qr-code"
                    />
                  </td>
                  <td>
                    <button
                      className="label-button"
                      onClick={() => {
                        setSelectedProduct(data);
                        setIsOpen(true);
                      }}
                    >
                      Open Label
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Hidden labels, used only for "Print All Labels".
          Each product is repeated as many times as its quantity. */}
      <div id="print-all-labels" style={{ display: "none" }}>
        {products.map((data, index) =>
          Array.from({ length: getQty(data) }).map((_, copy) => (
            <div className="bulk-label" key={`${index}-${copy}`}>
              {renderLabel(data, false)}
            </div>
          ))
        )}
      </div>

      {isOpen && selectedProduct && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setIsOpen(false)}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "500px",
              height: "100%",
              maxHeight: "500px",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              borderRadius: "8px",
              padding: "10px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {renderLabel(selectedProduct, true)}
            <div style={{display: "flex", gap: "10px", marginTop: "60px"}}>
              <button
                onClick={() => printLabel('pk')}
                style={{
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "white",
                  backgroundColor: "#004aad",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  width: "150px",
                  textAlign: "center",
                  marginTop: "5px"
                }}
              >
                Print Order Label
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderedProducts;